export default __webpack_public_path__ + "static/media/nishat (1)[1043].4de839f0.jpg";